import { render, staticRenderFns } from "./ShowOrderItems.vue?vue&type=template&id=7dffab07&scoped=true&"
import script from "./ShowOrderItems.vue?vue&type=script&lang=js&"
export * from "./ShowOrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffab07",
  null
  
)

export default component.exports